import React from "react";
import "./Discover.css";
import star1 from '../../Images/Group 1321315497.png'


const Discover = () => {
  return (
    <div className="unique-container">
      <div className="header">
        <h1>A Marketplace Like No Other</h1>
        <p>A platform designed just for you</p>
      </div>

      <div className="content-wrapper">
        <div className="phone-container">
          <img
            src={star1}
            alt="Kritika Khurana"
            className="phone-image"
          />
         
        </div>
      </div>
    </div>
  );
};

export default Discover;
